import { useEffect, useState } from 'react';

import { fetch_payout_ifsc } from '../api';
import { IFSC_UNAVAILABLE_TEXT, ifsc_hint_view } from './adapters';
import { ifsc_params } from './requests';

/* Any failure becomes a hint, never an error: the review actions do not depend on it. */
const useIfscLookup = (ifsc) => {
  const [hint, setHint] = useState(null);

  useEffect(() => {
    setHint(null);
    if (!ifsc) return undefined;
    let live = true;
    fetch_payout_ifsc(ifsc_params(ifsc).ifsc)
      .then((d) => live && setHint(ifsc_hint_view(d)))
      .catch(() => live && setHint({ text: IFSC_UNAVAILABLE_TEXT, warn: true }));
    return () => {
      live = false;
    };
  }, [ifsc]);

  return hint;
};

export default useIfscLookup;
